import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserFollowing } from '../../services/followService';
import supabase from '../../services/supabase';
import { FollowButton, Button } from '../../components/buttons';

export default function FollowingList() {
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!username) {
      setError('User not found.');
      setLoading(false);
      return;
    }
    const fetchFollowing = async () => {
      setLoading(true);
      setError(null);
      // 1. Get user_id by username (case-insensitive)
      const { data: profile, error: profileError } = await supabase
        .from('user_profiles')
        .select('user_id, username')
        .ilike('username', username)
        .single();
      console.log('Profile lookup result:', profile, profileError);
      if (profileError || !profile) {
        setError('User not found.');
        setLoading(false);
        return;
      }
      // 2. Get following by user_id
      const { data, error } = await getUserFollowing(profile.user_id);
      console.log('Following fetch result:', data, error);
      if (error) {
        setError('Failed to fetch following.');
        setLoading(false);
        return;
      }
      setFollowing(data || []);
      setLoading(false);
    };
    fetchFollowing();
  }, [username]);

  return (
    <div style={{ padding: '2rem', maxWidth: 500, margin: '0 auto', marginTop: '100px' }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24 }}>Following</h2>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && following.length === 0 && <p>Not following anyone yet.</p>}
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {following.map((f) => (
          <li
            key={f.id}
            className="user-list-card"
            style={{
              display: 'flex',
              alignItems: 'center',
              background: 'rgba(255,255,255,0.6)',
              borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
              padding: '12px 20px',
              marginBottom: 16,
              transition: 'box-shadow 0.2s',
            }}
          >
            <div
              style={{ display: 'flex', alignItems: 'center', flex: 1, cursor: 'pointer' }}
              onClick={() => navigate(`/profile/${f.profile.username}`)}
              title={`View ${f.profile.username}'s profile`}
            >
              {f.profile.profilePicture ? (
                <img
                  src={f.profile.profilePicture}
                  alt={f.profile.username}
                  className="avatar avatar-medium"
                  style={{ marginRight: 16 }}
                />
              ) : (
                <div className="avatar avatar-medium avatar-fallback" style={{ marginRight: 16 }}>
                  <span className="avatar-initial">{(f.profile.username || f.email || '?')[0]}</span>
                </div>
              )}
              <span className="profile-username" style={{ fontSize: 18, fontWeight: 500 }}>
                {f.profile.username || f.email || f.id}
              </span>
            </div>
            <button
              className="unfollow-button"
              style={{ marginLeft: 16, backgroundColor: '#e63946', color: 'white', border: 'none', padding: '8px 18px', borderRadius: 16, fontWeight: 600, fontSize: 15, cursor: 'pointer', transition: 'all 0.3s ease' }}
              onClick={async (e) => {
                e.stopPropagation();
                // Unfollow logic
                const { error } = await import('../../services/followService').then(m => m.unfollowUser(f.profile.user_id));
                if (!error) {
                  setFollowing((prev) => prev.filter((u) => u.profile.user_id !== f.profile.user_id));
                } else {
                  alert('Failed to unfollow.');
                }
              }}
            >
              Unfollow
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
} 